import { TransferOperation } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export { TransferOperation };

export const transferOperationDictionary = createSimpleDictionary([
    { id: TransferOperation.Deposit, name: 'dictionaries.transferOperation.deposit' },
    { id: TransferOperation.Withdrawal, name: 'dictionaries.transferOperation.withdrawal' },
]);
